import React, { useState, useEffect } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import { useStyles, styles } from './EditProcedureStyles';
import { Modal, Select, Input, Transfer, Icon, Button, Tabs, Spin, message, Checkbox, DatePicker, Alert } from 'antd';
import AttachFileContainer from 'app/containers/AttachFileContainer/AttachFileContainer';
import AzureMPContainer from 'app/containers/AzureMSContainer/AzureMSContainer';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import moment from 'moment';

import ApiService from 'app/services/ApiService'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourse, courseClear, courseFilterClear, fetchCourseFilter, fetchTestAvailableCourseById, courseTestAvailableClear } from 'app/actions/CourseActions';
import { clearCourseMultimedia } from 'app/actions/CourseMultimediaActions';
import { attachmentClear } from "app/actions/AttachmentActions";
import isEmpty from 'app/utils/IsEmpty';

import { fetchCategoryAvailableCourseById, fetchCategoryAvailableCourseApproveById } from 'app/actions/CourseActions';
import { fetchTechnicalRepresentativeFilter } from 'app/actions/TechnicalRepresentativeActions';
import MediaPlayer from '../MediaPlayer';

const { TextArea } = Input;
const { confirm } = Modal;
const { TabPane } = Tabs;

export default function EditProcedure(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState(6);
    const [isCourse, setCourseStatus] = useState(true);
    const [subdir, setSubdir] = useState([]);
    const [subdirCategory, setSubdirCategory] = useState(undefined);
    const [subdirCategoryApprove, setSubdirCategoryApprove] = useState(undefined);
    const [special, setSpecial] = useState([]);
    const [courseFolio, setCourseFolio] = useState('');
    const [courseName, setCourseName] = useState('');
    const [courseCode, setCourseCode] = useState('');
    const [description, setDesc] = useState('');
    const [courseSupportFileDate, setCourseSupportFileDate] = useState(null);
    const [loadDocument, setLoadDocument] = useState(false);
    const [version, setVersion] = useState(0);

    const [evaluation, setEvaluation] = useState([]);
    const [workCycle, setWorkCycle] = useState([]);
    const [targetWorkCycle, settargetWorkCycle] = useState([]);
    const [sourceWorkCycle, setsourceWorkCycle] = useState([]);
    const [course, setCourse] = useState([]);
    const [idCourse, setIdCourse] = useState(null);
    const [sourceCategory, setsourceCategory] = useState([]);
    const [targetCategory, settargetCategory] = useState([]);
    const [sourceCategoryApprove, setsourceCategoryApprove] = useState([]);
    const [targetCategoryApprove, settargetCategoryApprove] = useState([]);
    const [sourceClientProcedure, setsourceClientProcedure] = useState([]);
    const [targetClientProcedure, settargetClientProcedure] = useState([]);
    const [sourceHomologousProcedure, setsourceHomologousProcedure] = useState([]);
    const [targetHomologousProcedure, settargetHomologousProcedure] = useState([]);
    const [targetTest, settargetTest] = useState([]);
    const [sourceTest, setsourceTest] = useState([]);
    const [isLoaded, setLoadData] = useState(false);
    const [ischangeWorkC, setChangeWorkC] = useState(false);
    const [ischangeEvaluation, setChangeEvaluation] = useState(false);
    const [isLoadedCourseAsig, setLoadDataCourseAsign] = useState(false);
    const [isLoadedCourseApproveAsig, setLoadDataCourseApproveAsign] = useState(false);
    const [isLoadedClientProcedureAsig, setLoadDataClientProcedureAsign] = useState(false);
    const [isLoadedHomologousProcedureAsig, setLoadDataHomologousProcedureAsign] = useState(false);
    const [isLoadedTestAsig, setLoadDataTestAsign] = useState(false);
    const [isLoadedWorkCycleAsig, setLoadDataWorkCycleAsign] = useState(false);
    const [isLoadedWorkCycleAsigSel, setLoadDataWorkCycleAsignSel] = useState(false);
    const [isLoadedTestEvalAsigSel, setLoadDataTestEvalAsigSel] = useState(false);
    const [migrate, setMigrate] = useState();
    const [video, setVideo] = useState();
    const [localAttachment, setAttachment] = useState();
    const [listItems, setListItems] = useState([
        { text: 'Documento', icon: 'file-text', isActive: false },
        { text: 'Puestos', icon: 'gold', isActive: false },
        { text: 'Multimedia', icon: 'play-square', isActive: false },
        { text: 'Evaluación', icon: 'profile', isActive: false },
        { text: 'Ciclo de trabajo', icon: 'tool', isActive: false },
        { text: 'Clas. Cliente y Proc. homólogo', icon: 'snippets', isActive: false },
    ])
    const [idTraining, setIdTraining] = useState(undefined);
    const [idSystemSpecialty, setIdSystemSpecialty] = useState(null);
    const [notApply, setNotApply] = useState(undefined);
    const [disabledOption] = useState(props?.editParam?.statusName === "BAJA" ? true : false)
    const [headerEditedDate, setHeaderEditedDate] = useState(null);

    const [applyAll, setApplyAll] = useState(undefined);
    const [applyGCM, setApplyGCM] = useState(undefined);
    const [notApplyColab, setNotApplyColab] = useState(undefined);

    const [onSiteTest, setOnSiteTest] = useState(undefined);

    const [notShowCotplayHub, setNotShowCotplayHub] = useState(undefined);

    const {
        trainingSelect,
        isLoadTrainingSelect
    } = useSelector(state => state.TrainingReducer)

    const {
        systemSpecialty,
        isLoadSystemSpecialty
    } = useSelector(state => state.SystemReducer)

    const {
        isLoadingApprove
    } = useSelector(state => state.Course);

    const {
        siteId
    } = useSelector(state => state.Auth)

    const {
        Permissions
        , Roles
    } = useSelector(state => state.Auth.item.User);

    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSystem = systemSpecialty.filter(x => x.isSystem).map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSpecialty = systemSpecialty.filter(x => !x.isSystem && x.idTraining === idTraining).map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    function disabledDate(current) {
        return current && current < moment().subtract(1, 'days');
    }

    const documentStatusValidation = () => {
        const completed = 1;
        const incomplete = 0;
        const unload = -1;
        let documentStatus = loadDocument ? courseSupportFileDate !== null ? completed : incomplete : unload;

        let response = documentStatus == -1 && idTraining === 'TK0000000001' ? true : false;

        return response
    }

    const courseSupportFileDate_ = () => {

        if (!!courseSupportFileDate) {
            let date = courseSupportFileDate.split('/');
            if (date.length === 1) {
                var jdate = courseSupportFileDate.split('T');
                date = jdate[0].split('-');
            }
            let fecha = new Date(date[0], date[1] - 1, date[2]);
            return fecha;
        }
        return courseSupportFileDate;
    }

    const permisosArray = () => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })
        let response = [];
        permissions.forEach(row => {
            switch (row) {
                case "ModuleCourseDocument":
                    response.push("ModuleCourseDocument");
                    break;
                case 'ModuleCourseCategory':
                    response.push("ModuleCourseCategory");
                    break;
                case "ModuleCourseMultimedia":
                    response.push("ModuleCourseMultimedia");
                    break;
                case "ModuleCourseEvaluation":
                    response.push("ModuleCourseEvaluation");
                    break;
                case "ModuleCourseDutyCycle":
                    response.push("ModuleCourseDutyCycle");
                    break;
                case "ModuleCourseClientProcedure":
                    response.push("ModuleCourseClientProcedure");
                    break;
            }

        })
        return response
    }

    useEffect(() => {
        if (courseName !== '') setLoadData(true);
        if (targetCategory.length > 0) setLoadDataCourseAsign(true);
        if (targetCategoryApprove.length > 0) setLoadDataCourseApproveAsign(true);
        if (targetClientProcedure.length > 0) setLoadDataClientProcedureAsign(true);
        if (targetHomologousProcedure.length > 0) setLoadDataHomologousProcedureAsign(true);
        if (targetTest.length > 0) setLoadDataTestAsign(true);
        if (targetWorkCycle.length > 0) setLoadDataWorkCycleAsign(true);
        if (workCycle.length > 0) setLoadDataWorkCycleAsignSel(true);
        if (evaluation.length > 0) setLoadDataTestEvalAsigSel(true);

        if (courseName === '' && !isLoaded) {
            setCourseFolio(props.isVersion ? '' : props.editParam.courseFolio);
            setCourseName(props.editParam.courseName);
            setIdCourse(props.editParam.idCourse);
            setCourseCode(props.editParam.courseCode);
            setDesc(props.editParam.courseDescription);
            setCourseSupportFileDate(props.editParam.courseSupportFileDate);
            setLoadDocument(props.editParam.document);
            setCourse(props.editParam);
            setVersion(props.editParam.courseVersion);
            setSpecial([{ idSpecialty: props.editParam.idSpecialty }]);
        }

        setsourceCategory(props.courseCategory);
        setsourceCategoryApprove(props.courseCategoryApprove);
        setsourceClientProcedure(props.courseClientProcedure);
        setsourceHomologousProcedure(props.courseHomologousProcedure);
        setsourceTest(props.courseTest);
        setsourceWorkCycle(props.courseWorkCycle);

        if (targetCategory.length === 0 && !isLoadedCourseAsig)
            settargetCategory(props.courseCategoryAsig);

        if (targetCategoryApprove.length === 0 && !isLoadedCourseApproveAsig)
            settargetCategoryApprove(props.courseCategoryApproveAsig);


        if (targetClientProcedure.length === 0 && !isLoadedClientProcedureAsig)
            settargetClientProcedure(props.courseClientProcedureAsig);

        if (targetHomologousProcedure.length === 0 && !isLoadedHomologousProcedureAsig)
            settargetHomologousProcedure(props.courseHomologousProcedureAsig);

        if (targetTest.length === 0 && !isLoadedTestAsig)
            settargetTest(props.courseTestAsig);

        if (targetWorkCycle.length === 0 && !isLoadedWorkCycleAsig) {
            settargetWorkCycle(props.courseWorkCycleAsig);
        }

        if (workCycle.length === 0 && !isLoadedWorkCycleAsigSel) {
            if (props.courseWorkCycleAsig.length > 0)
                setWorkCycle([{ idTest: props.courseWorkCycleAsig[0] }]);
        }

        if (evaluation.length === 0 && !isLoadedTestEvalAsigSel) {
            if (props.courseTestAsig.length > 0)
                setEvaluation([{ idTest: props.courseTestAsig[0] }]);
        }

        if (isEmpty(subdir)) setSubdir([{
            idSubdirection: idSubdirection,
            subdirectionName: subdirectionName,
            deleted: false
        }])

        if (subdirCategory === undefined) setSubdirCategory(idSubdirection);
        if (subdirCategoryApprove === undefined) setSubdirCategoryApprove(idSubdirection);

        if (idTraining === undefined) setIdTraining(props.editParam.idTraining);
        if (idSystemSpecialty === null) setIdSystemSpecialty(props.editParam.systemSpecialtyId)
        if (notApply === undefined) setNotApply(!props.editParam.evaluation)

        if (applyAll == undefined) setApplyAll(props?.editParam?.applyAll)
        if (applyGCM == undefined) setApplyGCM(props?.editParam?.applyAllSubdirections)
        if (notApplyColab == undefined) setNotApplyColab(props?.editParam?.notApplyPosition)
        if (notShowCotplayHub == undefined) setNotShowCotplayHub(props?.editParam?.notShowCotplayHub);

        if (onSiteTest == undefined) setOnSiteTest(props?.editParam?.idEvaluationType == 2);




        // if (notShowCotplayHub == false) {
        //     if (props?.editParam?.notShowCotplayHub != null) {
        //         setOnSiteTest(props?.editParam?.notShowCotplayHub);
        //     }
        // }
    })

    const setValueOnSite = (val) => {
        setOnSiteTest(val);
    }

    const findSubdir = (params, item) => {
        let temp = [];
        params.subdirs.forEach(v => {
            if (String(v.idSubdirection) === item.key) temp.push(v);

        });
        setSubdir(temp);
    }

    const setNewEditedDate = (date, dateString) => {
        setHeaderEditedDate(dateString !== "" ? dateString.split('/').reverse().join('/') : null);
    }

    const setApplyAll_ = (item) => {

        setApplyAll(item.target.checked)

        setSubdirCategory(idSubdirection)
        setSubdirCategoryApprove(idSubdirection)
        findCategoryBySubdirection(idSubdirection)
        //settargetCategory([]);
    }

    const setApplyGCM_ = item => {
        setApplyGCM(item.target.checked)
    }

    const setDontApply = (item) => {
        setNotApplyColab(item)
        setSubdirCategory(idSubdirection)
        setSubdirCategoryApprove(idSubdirection)
        findCategoryBySubdirection(idSubdirection)
        //settargetCategory([]);
    }

    const findCategoryBySubdirection = (item) => {
        setSubdirCategory(item);
        dispatch(fetchCategoryAvailableCourseById({
            idCourse: idCourse,
            isApprover: false,
            idSubdirection: item
        }, targetCategory.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)))
    }

    const findCategoryBySubdirectionApprove = (item) => {
        setSubdirCategoryApprove(item);
        dispatch(fetchCategoryAvailableCourseApproveById({
            idCourse: idCourse,
            isApprover: true,
            idSubdirection: item
        }, targetCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)))
    }

    const findSpecialty = (params, item) => {
        let temp = [];
        params.specialty.forEach(v => {
            if (String(v.idSpecialty) === item.key) temp.push(v);
        });
        setSpecial(temp);
    }

    const findEvaluation = (params, item) => {
        let temp = [];
        params.forEach(v => {
            if (String(v.idTest) === item) temp.push(v);
        });
        setEvaluation(temp);
        setChangeEvaluation(true);
    }

    const findWorkCycle = (params, item) => {
        let temp = [];
        params.forEach(v => {
            if (String(v.idTest) === item) temp.push(v);
        });
        setWorkCycle(temp);
        setChangeWorkC(true);
    }
    const attachmentClick = (k, i) => {
        setSelectedIndex(i);
        setCourseStatus(false);
        const data = [...listItems];
        data.forEach(i => i.isActive = false);
        let indx = data.findIndex(x => x.text === k.text)
        data[indx].isActive = true;
        setListItems(data)
    }

    const handleClick = () => {
        setSelectedIndex(6);
        setCourseStatus(true);
        const data = [...listItems];
        data.forEach(i => i.isActive = false);
        setListItems(data)
    }

    const changeCategory = (e, d, m) => {
        setLoadDataCourseAsign(true);
        if (d === 'right') {
            settargetCategory([...targetCategory, ...m.map(i => ({ idCategory: i, idSubdirection: subdirCategory }))]);
        }
        else {
            settargetCategory([...targetCategory.filter(x => !m.includes(x.idCategory))]);
        }
    }

    const changeCategoryApprove = (e, d, m) => {
        setLoadDataCourseApproveAsign(true);
        if (d === 'right') {
            settargetCategoryApprove([...targetCategoryApprove, ...m.map(i => ({ idCategory: i, idSubdirection: subdirCategoryApprove }))]);
        }
        else {
            settargetCategoryApprove([...targetCategoryApprove.filter(x => !m.includes(x.idCategory))]);
        }
    }

    const filterOptionCategory = (inputValue, option) => {
        return option.categoryName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const filterOptionClientProcedure = (inputValue, option) => {
        return option.procedureName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const filterOptionHomologousProcedure = (inputValue, option) => {
        return option.procedureName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const {
        idSubdirection,
        employeeId,
        subdirectionName
    } = useSelector(state => state.Auth.employeeById)

    const doesNotApply = (check) => {
        setNotApply(check);
        setEvaluation([]);
        setChangeEvaluation(true);
    }

    const enableDateModified = () => {
        return true;
        // let { editParam } = props;
        // if (editParam.courseName != courseName || editParam.courseCode != courseCode) return false;
        // return true;
    }

    const todayDate = () => {

        return moment()
    }

    const enableDateModifiedDate = () => {
        let { editParam } = props;
        if ((editParam.courseName != courseName || editParam.courseCode != courseCode) && (headerEditedDate != '' && headerEditedDate != null)) return false;
        return true;
    }

    const showConfirm = (type) => {

        confirm({
            title: props.isVersion ? '¿Desea Versionar Procedimiento?' : '¿Guardar Procedimiento?',
            content: courseName,
            okText: props.isVersion ? 'Versionar' : 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                const listCategory = targetCategory.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection }));
                let idsEval = evaluation.map(i => i.idTest);
                let idsWork = workCycle.map(i => i.idTest);
                const data = {
                    idCourse: idCourse,
                    SubdirectionId: subdir[0].idSubdirection,
                    idTraining: idTraining,
                    isSystem: idTraining === 'TK0000000002',
                    idSystemSpecialty: idSystemSpecialty,
                    courseCode: courseCode,
                    courseName: courseName,
                    courseDescription: description,
                    courseVersion: props.isVersion ? (version + 1).toString() : version.toString(),
                    listCategory: listCategory,
                    listCategoryApprove: idTraining === 'TK0000000001' ? targetCategoryApprove.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection })) : [],
                    listClientProcedure: targetClientProcedure,
                    listHomologousProcedure: targetHomologousProcedure,
                    listTest: notApply ? [] : idsEval,
                    notApply: notApply,
                    listTestWorkCycle: idTraining === 'TK0000000001' ? idsWork : [],
                    courseSupportFileDate: props.isVersion ? null : courseSupportFileDate_(),
                    ChangeDate: headerEditedDate === null ? null : moment(headerEditedDate),

                }

                const data2 = data;
                data2.IsAdminGeneral = validateAdminGeneralRol();
                data2.PermisosPantalla = validateAdminGeneralRol() ? permisosArray() : [];

                return props.isVersion ? ApiService.setVersionCourse(data, 'POST').then(
                    response => {
                        props.setTab('1')
                        setCourse(response)
                        dispatch(courseFilterClear());
                        dispatch(fetchCourseFilter({
                            employeeId: employeeId,
                            subdirectionId: idSubdirection
                        }));
                        message.success(`Se generó nueva versión de ${courseName} correctamente!`);
                        dispatch(fetchCourse({
                            ...props.formData,
                            employeeId: employeeId,
                            subdirectionId: idSubdirection,
                            IsAdminGeneral: validateAdminGeneralRol(),
                            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                        }));
                    },
                    error => {

                    }
                ) :
                    ApiService.setCourses(data2, 'PUT')
                        .then(
                            response => {
                                setCourse(response)
                                dispatch(courseFilterClear());
                                dispatch(fetchCourseFilter({
                                    employeeId: employeeId,
                                    subdirectionId: idSubdirection
                                }));
                                confirm({
                                    title: 'Se editó el Procedimiento.',
                                    content: '¿Desea continuar?',
                                    okText: 'Aceptar',
                                    cancelText: 'Más tarde',
                                    onOk() {
                                        const data = [...listItems];
                                        if (validateAdminGeneralRol()) {
                                            var arrModules = listItems.filter(x => validateViewAdminGeneral().includes(x.text));
                                            if (arrModules.length > 0) {
                                                attachmentClick(arrModules[0], 0)
                                            }
                                        } else {
                                           
                                            if (idTraining === "TK0000000002") {
                                                setSelectedIndex(1);
                                                data[1].isActive = true;
                                            }
                                            else {
                                                setSelectedIndex(0);
                                                data[0].isActive = true;
                                            }
                                        }
                                    

                                        setListItems(data);
                                        setCourseStatus(false);

                                        dispatch(courseClear());
                                        dispatch(fetchCourse({
                                            ...props.formData,
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection,
                                            IsAdminGeneral: validateAdminGeneralRol(),
                                            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                        }));
                                        dispatch(courseFilterClear());
                                        dispatch(fetchCourseFilter({
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection
                                        }));
                                    },
                                    onCancel() {
                                        dispatch(courseClear());
                                        dispatch(fetchCourse({
                                            ...props.formData,
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection,
                                            IsAdminGeneral: validateAdminGeneralRol(),
                                            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                        }));
                                        dispatch(courseFilterClear());
                                        dispatch(fetchCourseFilter({
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection
                                        }));
                                        props.setTab('1')
                                    },
                                });
                            }, error => {
                                Modal.error({
                                    title: 'Ops, error de conexión',
                                    content: 'Se perdió la conexión de red, intente más tarde.',
                                });
                            }
                        )
            },
            onCancel() { },
        });
    }
    useEffect(() => {
        let data = moment().format("DD/MM/YYYY");
        setNewEditedDate(moment(), data);
    })

    const showSecondaryConfirm = () => {
        confirm({
            title: '¿Guardar configuración de procedimiento?',
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                const listCategory = targetCategory.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection }));
                let idsEval = evaluation.map(i => i.idTest);
                let idsWork = workCycle.map(i => i.idTest);
                if (typeof migrate === "undefined") {
                    const data = {
                        idCourse: course.idCourse,
                        SubdirectionId: subdir[0].idSubdirection,
                        idTraining: idTraining,
                        isSystem: idTraining === 'TK0000000002',
                        idSystemSpecialty: idSystemSpecialty,
                        courseCode: course.courseCode,
                        courseName: course.courseName,
                        courseDescription: course.courseDescription,
                        courseVersion: course.courseVersion.toString(),
                        listCategory: listCategory,
                        listCategoryApprove: idTraining === 'TK0000000001' ? targetCategoryApprove.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection })) : [],
                        listClientProcedure: targetClientProcedure,
                        listHomologousProcedure: targetHomologousProcedure,
                        listTest: notApply ? [] : idsEval,
                        notApply: notApply,
                        listTestWorkCycle: idTraining === 'TK0000000001' ? idsWork : [],
                        courseSupportFileDate: courseSupportFileDate_(),
                        ApplyAll: applyAll,
                        ApplyAllSubdirections: applyGCM,
                        NotApplyPosition: notApplyColab,
                        IsPresential: onSiteTest,
                        notShowCotplayHub: notShowCotplayHub,
                        IsAdminGeneral: validateAdminGeneralRol(),
                        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                    };
                    return ApiService.setCourses(data, 'PUT')
                        .then(
                            response => {
                                dispatch(attachmentClear());
                                dispatch(courseClear());
                                dispatch(fetchCourse(
                                    {
                                        ...props.formData,
                                        employeeId: employeeId,
                                        subdirectionId: idSubdirection,
                                        IsAdminGeneral: validateAdminGeneralRol(),
                                        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                    }
                                ));
                                dispatch(clearCourseMultimedia());
                                dispatch(attachmentClear());
                                dispatch(courseFilterClear());
                                dispatch(fetchCourseFilter({
                                    employeeId: employeeId,
                                    subdirectionId: idSubdirection
                                }));
                                Modal.success({
                                    title: `Procedimiento guardado correctamente.`,
                                    content: response.testTitle,
                                }, props.setTab('1'));
                            }, error => {
                                Modal.error({
                                    title: 'Ops, error de conexión',
                                    content: 'Se perdió la conexión de red, intente más tarde.',
                                });
                            }
                        )
                }
                else
                    return ApiService.setAttachment(migrate).then(
                        () => {
                            dispatch(attachmentClear());
                            ApiService.setCourses({
                                idCourse: course.idCourse,
                                SubdirectionId: subdir[0].idSubdirection,
                                idTraining: idTraining,
                                isSystem: idTraining === 'TK0000000002',
                                idSystemSpecialty: idSystemSpecialty,
                                courseCode: course.courseCode,
                                courseName: course.courseName,
                                courseDescription: course.courseDescription,
                                courseVersion: course.courseVersion.toString(),
                                listCategory: listCategory,
                                listCategoryApprove: idTraining === 'TK0000000001' ? targetCategoryApprove.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection })) : [],
                                listClientProcedure: targetClientProcedure,
                                listHomologousProcedure: targetHomologousProcedure,
                                listTest: notApply ? [] : idsEval,
                                notApply: notApply,
                                listTestWorkCycle: idTraining === 'TK0000000001' ? idsWork : [],
                                courseSupportFileDate: courseSupportFileDate_(),
                                ApplyAll: applyAll,
                                ApplyAllSubdirections: applyGCM,
                                NotApplyPosition: notApplyColab,
                                IsPresential: onSiteTest,
                                notShowCotplayHub: notShowCotplayHub,
                                IsAdminGeneral: validateAdminGeneralRol(),
                                PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                            }, 'PUT')
                                .then(
                                    response => {
                                        dispatch(courseClear());
                                        dispatch(fetchCourse(
                                            {
                                                ...props.formData,
                                                employeeId: employeeId,
                                                subdirectionId: idSubdirection,
                                                IsAdminGeneral: validateAdminGeneralRol(),
                                                PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                            }
                                        ));
                                        dispatch(clearCourseMultimedia());
                                        dispatch(attachmentClear());
                                        dispatch(courseFilterClear());
                                        dispatch(fetchCourseFilter({
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection
                                        }));
                                        Modal.success({
                                            title: `Procedimiento guardado correctamente.`,
                                            content: response.testTitle,
                                        }, props.setTab('1'));
                                    }, error => {
                                        Modal.error({
                                            title: 'Ops, error de conexión',
                                            content: 'Se perdió la conexión de red, intente más tarde.',
                                        });
                                    }
                                )
                        }
                    );
            },
            onCancel() {
            },
        });
    }

    const filterOptionWorkCycle = (inputValue, option) => {
        return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    };

    const filterOptionEV = (inputValue, option) => {
        return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    };

    const hasProblemsToSave = () => {
        /* Nota: Este codigo puedo ser simplificado, pero la verdad se revuleve luego uno */

        const completed = 1;
        const incomplete = 0;
        const unload = -1;
        /* Establece estatus del documento */
        let documentStatus = loadDocument ? courseSupportFileDate !== null ? completed : incomplete : unload;


        if (validateAdminGeneralRol()) {
            var arrModules = permisosArray();
            var response = false;

            for (var i = 0; i < arrModules.length; i++) {
                switch (arrModules[i]) {
                    case "ModuleCourseDocument":
                        if (documentStatus == -1)
                            response = true
                        break;
                    case "ModuleCourseCategory":
                        if (targetCategory.length === 0 && targetCategoryApprove.length === 0 && !notApplyColab && !applyGCM && !applyAll)
                            response = true
                        break;
                    case "ModuleCourseMultimedia":
                        if (onSiteTest === false && video === undefined)
                            response = true
                        break;
                    case "ModuleCourseEvaluation":
                        if (evaluation.length === 0 && (notApply === undefined || !notApply))
                            response = true
                        break;
                    case "ModuleCourseDutyCycle":
                        if (workCycle.length === 0)
                            response = true
                        break;
                    case "ModuleCourseClientProcedure":
                        if (targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0)
                            response = true
                        break;
                }
            }

            return response;
        } else {
            if (documentStatus == -1 && idTraining === 'TK0000000001') {
                return true;
            }

            /* Se verifica que no halla problemas para guardar */
            let hasProblems = ((evaluation.length === 0 && (notApply === undefined || !notApply))
                && workCycle.length === 0 && targetCategory.length === 0 && targetCategoryApprove.length === 0
                //&& (subdir[0].idSubdirection === 3 && idTraining === 'TK0000000001') ? targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0 : false
                && targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0
                && (documentStatus !== completed)
                //&& (courseSupportFileDate === null || !loadDocument)
                || (documentStatus === incomplete)
                || idSystemSpecialty === undefined || idTraining === '' || courseCode === '' || courseName === ''
            )


            /* Se regresa la respuesta */
            return hasProblems;
        }
    }
    const validateAdminGeneralRol = () => {
        let findRol = Roles.find(rol => rol.NameRole.includes("Administrador General"))
        return findRol ? true : false;
    }

    const validateViewAdminGeneral = () => {

        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })

        let response = [];

        permissions.forEach(row => {
            switch (row) {
                case "ModuleCourseDocument":
                    response.push("Documento");
                    break;
                case 'ModuleCourseCategory':
                    response.push("Puestos");
                    break;
                case "ModuleCourseMultimedia":
                    response.push("Multimedia");
                    break;
                case "ModuleCourseEvaluation":
                    response.push("Evaluación");
                    break;
                case "ModuleCourseDutyCycle":
                    response.push("Ciclo de trabajo");
                    break;
                case "ModuleCourseClientProcedure":
                    response.push("Clas. Cliente y Proc. homólogo");
                    break;
            }

        })


        return response
    }

    const validateViewOptionsAdminGeneral = (item) => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("CheckBox para")).map(item => {
            return item.NameResource;
        })

        switch (item) {
            case "applyAll":
                return permissions.find(item => item === 'cbxCourseAllSubdirection') ? true : false;
            case "applyGCM":
                return permissions.find(item => item === 'cbxCourseAllGCM') ? true : false;
            case "notApplyColab":
                return permissions.find(item => item === 'cbxCourseNoApply') ? true : false;
            case "notApply":
                return permissions.find(item => item === 'cbxCourseNoApplyEvaluation') ? true : false;

        }

        return false
    }

    const applyAllCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox disabled={applyGCM || notApplyColab} checked={applyAll} onChange={setApplyAll_}>Aplica a todos los empleados de la dirección</Checkbox>
            </Grid>
        )
    }
    const applyGCMCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox disabled={applyAll || notApplyColab} checked={applyGCM} onChange={setApplyGCM_}>Aplica a todos los empleados del GCM</Checkbox>
            </Grid>
        )
    }
    const notApplyCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox checked={notApplyColab} onChange={(e) => setDontApply(e.target.checked)} disabled={applyAll || applyGCM}>No aplica</Checkbox>
            </Grid>
        )
    }
    const notApplyEvaCB = () => {
        return (
            <Checkbox disabled={siteId !== 'HUB' || disabledOption} checked={notApply} onChange={(e) => doesNotApply(e.target.checked)}>No aplica</Checkbox>
        )
    }


    return (
        <div>
            <Grid container direction="row">
                <Grid container direction="row">
                    <Grid xs={4} item>
                        <CardContent>
                            <div>
                                <List component="nav" disablePadding>
                                    <ListItem button className={classes.nested} selected={selectedIndex === 6} onClick={handleClick} key={6}>
                                        <ListItemIcon className={classes.icon}>
                                            <Icon type="folder" theme='twoTone' />
                                        </ListItemIcon>
                                        <ListItemText primary={courseCode !== '' ? `${courseCode}` : 'Procedimiento'} />

                                    </ListItem>
                                </List>
                                <Divider />
                                <List component="nav" disablePadding>
                                    {props.isLoadingTest && props.isLoadingWorkCycle || isLoadingApprove ? <div style={styles.spin}><Spin tip="Cargando ..." /></div> : ''}
                                    {
                                        validateAdminGeneralRol() ?
                                            listItems.filter(x => validateViewAdminGeneral().includes(x.text)).map((i, key) => {
                                                return (<ListItem button className={classes.nested} selected={i.isActive} onClick={() => attachmentClick(i, key)} key={key} disabled={props.isVersion}>
                                                    <ListItemIcon className={classes.icon}>
                                                        <Icon type={i.icon} />
                                                    </ListItemIcon>
                                                    <ListItemText secondary={i.text} />
                                                </ListItem>)
                                            })
                                            :
                                            idTraining === 'TK0000000001' ?
                                                subdir[0].idSubdirection == 3 ?
                                                    listItems.map((i, key) => {
                                                        return (<ListItem button className={classes.nested} selected={i.isActive} onClick={() => attachmentClick(i, key)} key={key} disabled={props.isVersion}>
                                                            <ListItemIcon className={classes.icon}>
                                                                <Icon type={i.icon} />
                                                            </ListItemIcon>
                                                            <ListItemText secondary={i.text} />
                                                        </ListItem>)
                                                    }) :
                                                    listItems.filter(x => x.text !== 'Clas. Cliente y Proc. homólogo').map((i, key) => {
                                                        return (<ListItem button className={classes.nested} selected={i.isActive} onClick={() => attachmentClick(i, key)} key={key} disabled={props.isVersion}>
                                                            <ListItemIcon className={classes.icon}>
                                                                <Icon type={i.icon} />
                                                            </ListItemIcon>
                                                            <ListItemText secondary={i.text} />
                                                        </ListItem>)
                                                    })
                                                : idTraining === 'TK0000000002' ?
                                                    listItems.filter(x => x.text !== 'Ciclo de trabajo' && x.text !== 'Clas. Cliente y Proc. homólogo' && x.text !== 'Documento').map((i, key) => {
                                                        return (<ListItem button className={classes.nested} selected={i.isActive} onClick={() => attachmentClick(i, key + 1)} key={key} disabled={props.isVersion}>
                                                            <ListItemIcon className={classes.icon}>
                                                                <Icon type={i.icon} />
                                                            </ListItemIcon>
                                                            <ListItemText secondary={i.text} />
                                                        </ListItem>)
                                                    })
                                                    :
                                                    listItems.filter(x => x.text !== 'Ciclo de trabajo' && x.text !== 'Clas. Cliente y Proc. homólogo').map((i, key) => {
                                                        return (<ListItem button className={classes.nested} selected={i.isActive} onClick={() => attachmentClick(i, key)} key={key} disabled={props.isVersion}>
                                                            <ListItemIcon className={classes.icon}>
                                                                <Icon type={i.icon} />
                                                            </ListItemIcon>
                                                            <ListItemText secondary={i.text} />
                                                        </ListItem>)
                                                    })
                                    }
                                </List>
                            </div>
                        </CardContent>
                    </Grid>
                    {/* secondary button */}
                    {!isCourse ?
                        <Grid xs={8} item>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Grid container direction="row">
                                        <Grid item xs={6}>
                                            {
                                                listItems[2].isActive ?
                                                    <Checkbox checked={onSiteTest} onChange={(e) => { setValueOnSite(e.target.checked) }}>Es presencial
                                                    </Checkbox> : null
                                            }
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className={classes.buttonsContainer}>
                                                {
                                                    siteId === 'HUB' ?
                                                        <Button
                                                            variant='contained'
                                                            type='primary'
                                                            onClick={showSecondaryConfirm}
                                                            disabled={disabledOption /*  ||hasProblemsToSave()*/}
                                                        > Guardar</Button> : null
                                                }
                                                <Button 
                                                    type="danger" 
                                                    ghost
                                                    variant='contained'
                                                    className={classes.button}
                                                    onClick={() => props.setTab('1')}
                                                >Cancelar</Button>
                                            </div>
                                        </Grid>
                                    </Grid>

                                    <div>
                                        {listItems[0].isActive ?
                                            <Grid item xs={12}>
                                                <TextEvents
                                                    text="Documentos"
                                                    color="cotemar"
                                                    size='subtitle'
                                                    weight="bold"
                                                />
                                                {documentStatusValidation() ?
                                                    <Alert
                                                        message="Disciplina Operacional requiere de al menos un documento para su guardado"
                                                        type="warning"

                                                    /> : ""
                                                }
                                                <AttachFileContainer
                                                    id={idCourse}
                                                    setMigrate={setMigrate}
                                                    courseSupportFileDate={courseSupportFileDate}
                                                    setCourseSupportFileDate={setCourseSupportFileDate}
                                                    loadDocument={loadDocument}
                                                    setAttachment={setAttachment}
                                                    localAttachment={localAttachment}
                                                    setLoadDocument={setLoadDocument}>
                                                    {(() => {
                                                        return <div />
                                                    })
                                                    }
                                                </AttachFileContainer>
                                            </Grid>
                                            : listItems[1].isActive ?

                                                <Grid container direction="row" spacing={1} >
                                                    {/* <Grid xs={6} item>
                                                        <Checkbox checked={applyAll} onChange={setApplyAll_}>Aplica a todos los empleados de la dirección</Checkbox>
                                                    </Grid>
                                                    <Grid xs={6} item>
                                                        <Checkbox checked={applyGCM} onChange={setApplyGCM_}>Aplica a todos los empleados del GCM</Checkbox>
                                                    </Grid> */}
                                                    {
                                                        validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("applyAll") ? applyAllCB() : <div></div>) : applyAllCB()
                                                    }
                                                    {
                                                        validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("applyGCM") ? applyGCMCB() : <div></div>) : applyGCMCB()
                                                    }
                                                    {
                                                        validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("notApplyColab") ? notApplyCB() : <div></div>) : notApplyCB()
                                                    }

                                                    <Grid xs={12} item>
                                                        <TextEvents
                                                            text='Selecciona puesto(s) de Colaborador(es)'
                                                            color='darker' x
                                                            size='label'
                                                            weight='medium'
                                                        />
                                                    </Grid>
                                                    {/* <Grid xs={6} item>
                                                        <Checkbox checked={notApplyColab} onChange={(e) => setDontApply(e.target.checked)} disabled={applyAll}>No aplica</Checkbox>
                                                    </Grid> */}

                                                    <Grid xs={12} item>

                                                        <SubdirectionsContainer>
                                                            {(params) => {
                                                                return (
                                                                    <Select
                                                                        disabled={true/*(siteId !== 'HUB' || disabledOption || applyAll || notApplyColab)*/}
                                                                        placeholder={'Selecciona subdirección'}
                                                                        value={subdirCategory !== undefined ? String(subdirCategory) : subdirCategory}
                                                                        // style={{ width: "740px" }}
                                                                        style={{ width: "98%" }}
                                                                        onChange={(item) => {
                                                                            findCategoryBySubdirection(item);
                                                                        }}
                                                                        showSearch
                                                                        filterOption={(input, option) =>
                                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {
                                                                            params.subdirs.map((item) =>
                                                                                <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                    {item.subdirectionName}
                                                                                </Select.Option>
                                                                            )
                                                                        }
                                                                    </Select>
                                                                )
                                                            }}
                                                        </SubdirectionsContainer>
                                                    </Grid>

                                                    <Grid
                                                        xs={12} item
                                                        style={{ width: '100%' }}
                                                    >
                                                        <Transfer
                                                            disabled={siteId !== 'HUB' || disabledOption || applyAll || notApplyColab || applyGCM}
                                                            dataSource={sourceCategory.filter(x => String(x.idSubdirection) === String(subdirCategory))}
                                                            titles={['Puestos disponibles', 'Puestos asignados']}
                                                            listStyle={{
                                                                width: '46.5%',
                                                                // width: 350,
                                                                height: 300,
                                                            }}
                                                            showSearch
                                                            filterOption={filterOptionCategory}
                                                            targetKeys={targetCategory.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)}
                                                            onChange={changeCategory}
                                                            render={item => item.categoryName} />
                                                    </Grid>

                                                    {
                                                        idTraining === 'TK0000000001' ?
                                                            <Grid xs={12} item>
                                                                <TextEvents
                                                                    text='Selecciona puesto(s) de Aprobador(es)'
                                                                    color='darker'
                                                                    size='label'
                                                                    weight='medium'
                                                                />
                                                                <SubdirectionsContainer>
                                                                    {(params) => {
                                                                        return (
                                                                            <Select
                                                                                disabled={siteId !== 'HUB' || disabledOption || applyAll || notApplyColab}
                                                                                placeholder={'Selecciona subdirección'}
                                                                                value={subdirCategoryApprove !== undefined ? String(subdirCategoryApprove) : subdirCategoryApprove}
                                                                                // style={{ width: "740px" }}
                                                                                style={{ width: "98%" }}
                                                                                onChange={(item) => {
                                                                                    findCategoryBySubdirectionApprove(item);
                                                                                }}
                                                                                showSearch
                                                                                filterOption={(input, option) =>
                                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                }
                                                                            >
                                                                                {
                                                                                    params.subdirs.map((item) =>
                                                                                        <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                            {item.subdirectionName}
                                                                                        </Select.Option>
                                                                                    )
                                                                                }
                                                                            </Select>
                                                                        )
                                                                    }}
                                                                </SubdirectionsContainer>
                                                            </Grid> : <div></div>
                                                    }

                                                    {
                                                        idTraining === 'TK0000000001' ?
                                                            <Grid xs={12} item >
                                                                <Transfer
                                                                    disabled={siteId !== 'HUB' || disabledOption || applyAll || notApplyColab || applyGCM}
                                                                    dataSource={sourceCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategoryApprove))}
                                                                    titles={['Puestos disponibles', 'Puestos asignados']}
                                                                    listStyle={{
                                                                        width: '46.5%',
                                                                        // width: 350,
                                                                        height: 300,
                                                                    }}
                                                                    showSearch
                                                                    filterOption={filterOptionCategory}
                                                                    targetKeys={targetCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategoryApprove)).map(i => i.idCategory)}
                                                                    onChange={changeCategoryApprove}
                                                                    render={item => item.categoryName} />
                                                            </Grid> : <div></div>
                                                    }
                                                </Grid>
                                                : listItems[2].isActive ?

                                                    <Grid item xs={12}>
                                                        <TextEvents
                                                            text="Multimedia - Videos"
                                                            color="cotemar"
                                                            size='subtitle'
                                                            weight="bold"
                                                        />
                                                        <Alert
                                                            message="Disclaimer"
                                                            description="Se deberá solicitar la autorización oficial para el uso de videos propiedad de un tercero (aún sean partes del video completo). Cuando sea la reproducción parcial de un video de un tercero, se deberá indicar al final la fuente y propietario del video. No deberá utilizarse los videos propios de Cotemar para otros fines que no sean los indicados en Cotplay."
                                                            type="error"
                                                        />
                                                        <br />
                                                        <AzureMPContainer id={idCourse} setVideo={setVideo} disabled={onSiteTest}>
                                                            {(() => {
                                                                props.setLoader(video)
                                                                return <div />
                                                            })}
                                                        </AzureMPContainer>

                                                        <Checkbox checked={notShowCotplayHub} onChange={(e) => { setNotShowCotplayHub(e.target.checked) }}>No mostrar CotPlay HUB
                                                        </Checkbox>
                                                    </Grid>
                                                    : listItems[3].isActive ?
                                                        <Grid xs={12} item >
                                                            <TextEvents
                                                                text='Selecciona la Evaluación'
                                                                color='darker'
                                                                size='label'
                                                                weight='medium'
                                                            />
                                                            <div>
                                                                <Select
                                                                    showSearch
                                                                    disabled={notApply || siteId !== 'HUB' || disabledOption}
                                                                    id="evaluation"
                                                                    value={!ischangeEvaluation ? (props.courseTestAsig.length > 0 ? String(props.courseTestAsig) : undefined) : (evaluation.length > 0 ? String([evaluation[0].idTest]) : undefined)}
                                                                    //defaultValue={{ key: !ischangeEvaluation ? String(props.courseTestAsig) : (evaluation.length > 0 ? String([evaluation[0].idTest]) : String(props.courseTestAsig)) }}
                                                                    style={{ width: "100%" }}
                                                                    placeholder='Selecciona la Evaluación'
                                                                    filterOption={filterOptionEV}
                                                                    onChange={(v) => {
                                                                        findEvaluation(sourceTest, v);
                                                                    }}
                                                                >
                                                                    {
                                                                        sourceTest.filter(x => x.idTraining === idTraining).map((item) => {
                                                                            return (
                                                                                <Select.Option key={String(item.idTest)} value={String(item.idTest)}>
                                                                                    {item.testFolio + ' - ' + item.testTitle}
                                                                                </Select.Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>

                                                                {
                                                                    validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("notApply") ? notApplyEvaCB() : <div></div>) : (idTraining !== 'TK0000000001' ? notApplyEvaCB() : <div></div>)
                                                                }

                                                            </div>
                                                        </Grid>
                                                        : listItems[4].isActive && (validateAdminGeneralRol() || idTraining === 'TK0000000001') ?
                                                            <Grid xs={12} item >
                                                                <TextEvents
                                                                    text='Selecciona el Ciclo de Trabajo'
                                                                    color='darker'
                                                                    size='label'
                                                                    weight='medium'
                                                                >
                                                                </TextEvents>
                                                                <Select
                                                                    id="work"
                                                                    showSearch
                                                                    disabled={siteId !== 'HUB' || disabledOption}
                                                                    value={!ischangeWorkC ? (props.courseWorkCycleAsig.length > 0 ? String(props.courseWorkCycleAsig) : undefined) : (workCycle.length > 0 ? String([workCycle[0].idTest]) : undefined)}
                                                                    //defaultValue={{ key: !ischangeWorkC ? String(props.courseWorkCycleAsig) : (workCycle.length > 0 ? String([workCycle[0].idTest]) : String(props.courseWorkCycleAsig)) }}
                                                                    style={{ width: "100%" }}
                                                                    placeholder='Selecciona el ciclo de trabajo'
                                                                    filterOption={filterOptionWorkCycle}
                                                                    onChange={(v) => {
                                                                        findWorkCycle(sourceWorkCycle, v);
                                                                    }}
                                                                >
                                                                    {sourceWorkCycle.map((item) => {
                                                                        return (
                                                                            <Select.Option key={String(item.idTest)} value={String(item.idTest)}>
                                                                                {item.testFolio + ' - ' + item.testTitle}
                                                                            </Select.Option>
                                                                        )
                                                                    })
                                                                    }
                                                                </Select>
                                                            </Grid>
                                                            :
                                                            (subdir[0].idSubdirection === 3 && idTraining === 'TK0000000001') ?
                                                                <Grid
                                                                    xs={12} item
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <Tabs defaultActiveKey="1">
                                                                        <TabPane tab="Clasificación del Cliente" key="1">
                                                                            <TextEvents
                                                                                text='Selecciona Clasificación del Cliente'
                                                                                color='darker'
                                                                                size='label'
                                                                                weight='medium'
                                                                            />
                                                                            <Transfer
                                                                                disabled={siteId !== 'HUB' || disabledOption}
                                                                                dataSource={sourceClientProcedure}
                                                                                titles={['Disponibles', 'Asignadas']}
                                                                                listStyle={{
                                                                                    width: '46.5%',
                                                                                    // width: 300,
                                                                                    height: 300,
                                                                                }}
                                                                                showSearch
                                                                                filterOption={filterOptionClientProcedure}
                                                                                targetKeys={targetClientProcedure}
                                                                                onChange={(e) => {
                                                                                    let sourceClientsChange = [...sourceClientProcedure];
                                                                                    let filtered = [];
                                                                                    const passed = [];
                                                                                    e.forEach(i => {
                                                                                        filtered = sourceClientsChange.filter(f => f.key === i)
                                                                                        passed.push(filtered[0])
                                                                                    });
                                                                                    sourceClientsChange.forEach(i => {
                                                                                        if (passed.length === 0) i.disabled = false;
                                                                                        passed.forEach(p => {
                                                                                            i.disabled = false;
                                                                                            if (i.idClient === p.idClient) i.disabled = true;
                                                                                            if (i.key === p.key) i.disabled = false;
                                                                                        })
                                                                                    })
                                                                                    setsourceClientProcedure(sourceClientsChange);
                                                                                    return settargetClientProcedure(e);
                                                                                }}
                                                                                render={item => item.procedureName} />
                                                                        </TabPane>
                                                                        <TabPane tab="Procedimientos Homólogos" key="2">
                                                                            <TextEvents
                                                                                text='Selecciona Procedimientos homólogos'
                                                                                color='darker'
                                                                                size='label'
                                                                                weight='medium'
                                                                            />
                                                                            <Transfer
                                                                                disabled={siteId !== 'HUB' || disabledOption}
                                                                                dataSource={sourceHomologousProcedure}
                                                                                titles={['Disponibles', 'Asignadas']}
                                                                                listStyle={{
                                                                                    width: '46.5%',
                                                                                    // width: 300,
                                                                                    height: 300,
                                                                                }}
                                                                                showSearch
                                                                                filterOption={filterOptionHomologousProcedure}
                                                                                targetKeys={targetHomologousProcedure}
                                                                                onChange={e => settargetHomologousProcedure(e)}
                                                                                render={item => item.procedureName} />
                                                                        </TabPane>
                                                                    </Tabs>
                                                                </Grid> : <div></div>
                                        }
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                        :
                        <Grid xs={8} item>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Grid container direction="row">
                                        <Grid item xs={12}>
                                            <TextInput
                                                disabled
                                                value={courseFolio}
                                                setValue={setCourseFolio}
                                                text='Folio'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode='input'
                                                onChange={e => setCourseFolio(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                            <Grid item xs={12}>
                                                <TextEvents
                                                    text='Subdirección Origen'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                />
                                                <SubdirectionsContainer>
                                                    {(params) => {
                                                        return (
                                                            <Select
                                                                disabled={true}
                                                                placeholder={'Selecciona subdirección'}
                                                                value={subdir.length > 0 ? String(subdir[0].idSubdirection) : null}
                                                                style={{ width: "100%" }}
                                                                onChange={(item) => {
                                                                    findSubdir(params, item);
                                                                }}
                                                            >
                                                                {
                                                                    params.subdirs.map((item) =>
                                                                        <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                            {item.subdirectionName}
                                                                        </Select.Option>
                                                                    )
                                                                }
                                                            </Select>
                                                        )
                                                    }}
                                                </SubdirectionsContainer>
                                            </Grid>
                                            <Grid container spacing={1} direction="row">
                                                <Grid item xs={6}>
                                                    <TextEvents
                                                        text='Tipo de Capacitación'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                    />
                                                    <Select
                                                        disabled={props.isVersion || version !== 0 || siteId !== 'HUB' || disabledOption}
                                                        placeholder={'Selecciona Tipo de Capacitación'}
                                                        loading={isLoadTrainingSelect}
                                                        value={idTraining}
                                                        style={{ width: "100%" }}
                                                        onChange={(item) => {
                                                            if (item !== idTraining) {
                                                                setEvaluation([]);
                                                                setChangeEvaluation(true);
                                                                dispatch(fetchTestAvailableCourseById(idCourse, item));
                                                            }
                                                            setIdTraining(item);
                                                            setIdSystemSpecialty(undefined);
                                                            setNotApply(false);
                                                        }}
                                                        showSearch
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {optionTraining}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextEvents
                                                        text='Especialidad/Sistema'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                    />
                                                    <Select
                                                        disabled={props.isVersion || version !== 0 || siteId !== 'HUB' || disabledOption}
                                                        placeholder={'Selecciona' + (idTraining === undefined ? ' un Tipo de Capacitación' : (idTraining === 'TK0000000002' ? ' Sistema' : ' Especialidad'))}
                                                        loading={isLoadSystemSpecialty}
                                                        value={idSystemSpecialty}
                                                        style={{ width: "100%" }}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        showSearch
                                                        onChange={(item) => {
                                                            setIdSystemSpecialty(item);
                                                        }}
                                                    >
                                                        {
                                                            idTraining === undefined ? [] : (
                                                                idTraining === 'TK0000000002' ? optionSystem : optionSpecialty
                                                            )
                                                        }
                                                    </Select>
                                                </Grid>
                                            </Grid>
                                            <TextInput
                                                //disabled={props.isVersion || version !== 0 || siteId !== 'HUB' || disabledOption}
                                                value={courseCode}
                                                setValue={setCourseCode}
                                                text='Código'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode='input'
                                                placeholder='Código'
                                                onChange={e => setCourseCode(e.target.value)}
                                            />
                                            <TextInput
                                                //  disabled={props.isVersion || version !== 0 || siteId !== 'HUB' || disabledOption}
                                                value={courseName}
                                                setValue={setCourseName}
                                                text='Nombre'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode='input'
                                                placeholder='Nombre'
                                                onChange={e => setCourseName(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <div>
                                        <TextEvents
                                            text='Descripción'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <TextArea
                                            disabled={siteId !== 'HUB' || disabledOption}
                                            value={description}
                                            onChange={e => setDesc(e.target.value)}
                                            autoSize={{ minRows: 5, maxRows: 6 }}
                                            placeholder='Descripción..'
                                        />
                                    </div>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                        </Grid>
                                        <Grid xs={6} item className={classes.gridSeparatorRight}>
                                            <TextInput
                                                disabled
                                                text='Estatus'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode="multiple"
                                                placeholder="Edición"
                                            >
                                            </TextInput>
                                        </Grid>
                                        <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                            <TextInput
                                                disabled
                                                value={props.isVersion ? version + 1 : version}
                                                setValue={setVersion}
                                                text='Versión'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode='input'
                                                placeholder='Versión'
                                                onChange={e => setVersion(e.target.value)}
                                            >
                                            </TextInput>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row">
                                        <Grid xs={6} item className={classes.gridSeparatorRight}>
                                            <TextEvents
                                                text='Fecha Edicion Actual'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <DatePicker
                                                format={'DD/MM/YYYY'}
                                                defaultValue={moment()}
                                                onChange={setNewEditedDate}
                                                disabled={(enableDateModified())}
                                            />

                                        </Grid>
                                        <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                            <TextEvents
                                                text='Ultima Fecha Edicion'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />

                                            <DatePicker
                                                format={'DD/MM/YYYY'}
                                                disabled={true}
                                                defaultValue={props.editParam.changeDate === null ? null : moment(props.editParam.changeDate)}
                                            />
                                        </Grid>

                                    </Grid>
                                    <div className={classes.buttonsContainer}>
                                        {
                                            siteId === 'HUB' ?
                                                <Button
                                                    disabled={subdir.length === 0 || idSystemSpecialty === undefined || idTraining === '' || courseCode === '' || courseName === '' || disabledOption || enableDateModifiedDate()}
                                                    variant='contained'
                                                    type='primary'
                                                    onClick={showConfirm}
                                                > {props.isVersion ? 'Versionar' : 'Guardar'}</Button> : null
                                        }
                                        <Button 
                                            type="danger" 
                                            ghost
                                            className={classes.button}
                                            onClick={() => props.setTab('1')}
                                        >Cancelar</Button>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </div>
    );
}